var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgMenuIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 64,
  height: 64,
  fill: "none",
  viewBox: "0 0 20 20"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#7654FD",
  fillRule: "evenodd",
  d: "M18 5a1 1 0 1 0 0-2H2a1 1 0 0 0 0 2zm0 4a1 1 0 1 0 0-2h-8a1 1 0 1 0 0 2zm1 3a1 1 0 0 1-1 1H2a1 1 0 1 1 0-2h16a1 1 0 0 1 1 1m-1 5a1 1 0 1 0 0-2h-8a1 1 0 1 0 0 2z"
})));
export default SvgMenuIcon;